if (!customElements.get('product-modal')) {
  if (typeof window.ModalDialog !== 'undefined') {
    customElements.define(
      'product-modal',
      class ProductModal extends window.ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        setTimeout(this.showActiveMedia.bind(this), 120);
      }

      showActiveMedia() {
        // 检查是否是 Portfolio Gallery 的弹窗（没有 data-media-id 结构）
        const portfolioModal = this.classList.contains('portfolio-media-modal');
        
        if (portfolioModal) {
          // Portfolio Gallery 弹窗：不需要处理 data-media-id，直接返回
          return;
        }
        
        // 原有的产品媒体弹窗逻辑（保留兼容性）
        const dataMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!dataMediaId) {
          return;
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${dataMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${dataMediaId}"]`);
        if (!activeMedia) {
          return;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const scrollContainer = this.querySelector('[role="document"]');
        if (!scrollContainer) {
          return;
        }

        // Determine the padding based on the window width
        const padding = window.innerWidth >= 750 ? 5 * parseFloat(getComputedStyle(document.documentElement).fontSize) : 20;

        // Get the height of the active media element and the scroll container
        const mediaHeight = activeMedia.offsetHeight;
        const containerHeight = scrollContainer.clientHeight;

        // Calculate the top position of the active media element relative to the scroll container
        const rect = activeMedia.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        let offsetTop = scrollContainer.scrollTop + rect.top - containerRect.top - padding;

        // If the element is smaller than the container, adjust the offset to center it
        if (mediaHeight < containerHeight) {
            offsetTop -= (containerHeight - mediaHeight) / 2;
        }

        scrollContainer.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
    );
  }
}

